<template>
  <div class="container float-container">
    <text-input
      :hint="placeholder"
      :scroll-on-focus="scrollOnFocus"
      :label="label"
      :value="value"
      :name="name"
      @input="onInput"
      @click="$emit('click')"
      @focus="$emit('focus')"
      :required="required"
      :maxlength="maxlength"
      :subhint="subhint"
      :validation-error="error"
      inputmode="text"
      pattern="/[A-Za-z\s]$/"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
export default {
  name: "TextInputCustom",
  components: { TextInput },
  props: [
    "placeholder",
    "label",
    "value",
    "name",
    "maxlength",
    "minlength",
    "subhint",
    "scrollOnFocus"
  ],
  data() {
    return {
      checked: false
    };
  },
  computed: {
    error() {
      if (this.checked) {
        if (this.isVoid()) {
          return "Tenés que ingresar este dato";
        } else if (!this.isValid()) {
          return "No se permiten caracteres especiales";
        }
      }
      return null;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.required) {
        const inputRegex = /^[A-Za-z\s]*$/;
        return inputRegex.test(this.value);
      }
      return true;
    }
  }
};
</script>

<style scoped></style>
